import { setBulkUploadThunk } from 'actions/bulkUpload/bulkUploadActions';
import { useAuth } from 'hooks';
import { BulkUploadWebSocketMessage } from 'model/WebSockets';
import { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { websocketLog } from './websocketLog';
import { useActionCableChannel } from './useActionCableChannel';

const BulkUploadWebSockets: FunctionComponent = () => {
    const auth = useAuth();
    const dispatch = useDispatch();

    const onReceived = useCallback(
        (message: BulkUploadWebSocketMessage) => {
            websocketLog('message', 'BulkUploadWebSockets', { event: message.event });

            if (message.event !== '') {
                dispatch(setBulkUploadThunk(message));
            }
        },
        [dispatch]
    );

    useActionCableChannel<BulkUploadWebSocketMessage>({
        channel: 'CustomersImportChannel',
        params: {
            marketplace_id: auth.marketplaceId,
            staff_id: auth.user?.staffId
        },
        enabled: Boolean(auth.signedIn && auth.marketplaceId),
        onReceived,
        subscriptionDeps: [auth.marketplaceId, auth.user?.staffId],
        logLabel: 'BulkUploadWebSockets'
    });

    return null;
};

export default BulkUploadWebSockets;
